import { logEvent } from 'firebase/analytics';
import { useEffect } from 'react';
import { useAnalytics } from 'reactfire';

export function PageViewLogger({ location }) {
  const analytics = useAnalytics();

  // By passing `location.pathname` to the second argument of `useEffect`,
  // we only log on first render and when the `pathname` changes
  useEffect(() => {
    logEvent(analytics, 'page_view', { page_location: location.href });
  }, [analytics, location.href]);

  return null;
}
